import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_caret",
  "use": "icon-icon_caret-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_caret\"><defs><style></style></defs><path d=\"M834.765 432.333l-307.2-363.93a20.48 20.48 0 0 0-29.696 0l-307.2 363.93a20.48 20.48 0 0 0 14.131 31.949h614.4a20.48 20.48 0 0 0 15.565-31.95zm0 159.334l-307.2 363.93a20.48 20.48 0 0 1-29.696 0l-307.2-363.93a20.48 20.48 0 0 1 14.131-31.949h614.4a20.48 20.48 0 0 1 15.565 31.95z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol